import { useEffect, useReducer } from 'react'
import { API, graphqlOperation } from 'aws-amplify'
import { onCreateWallCard } from '../graphql/subscriptions'
import {
  FETCH_DATA_INIT,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  ADD_CARD,
} from './constants'
import { createWallRecipient } from '../graphql/mutations'

const getWall = `query GetWall($id: ID!) {
  getWall(id: $id) {
    id
    status
    senderId
    senderName
    occasion
    layout    
    config
    greetingType
    passcode
    cards (sortDirection: DESC, limit: 999) {
        items {
            id
            text
            cardName
            senderId
            senderName            
            wallID
            createdAt
            updatedAt
        }
        nextToken
    }  
    recipients {
      items {
        id
        recipientId
        recipientName
        wallID
        createdAt
        updatedAt          
      }
    }  
    createdAt
    updatedAt   
  }
}
`
const fetchWallReducer = (state, action) => {
  switch (action.type) {
    case FETCH_DATA_INIT:
      return {
        ...state,
        isLoading: true,
        isError: false,
      }
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        wall: action.payload.wall,
        isGreeted: action.payload.isGreeted,
        isRecipient: action.payload.isRecipient,
      }
    case FETCH_DATA_FAILURE:
      return { ...state, isLoading: false, isError: true }
    case ADD_CARD:
      return { ...state, wall: action.payload, isGreeted: true }
    default:
      throw new Error()
  }
}

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const useFetchWallData = ({ userId, wallId, userName, recipientToken }) => {
  const initialState = {
    isLoading: true,
    isError: false,
    wall: {},
    isGreeted: false,
    isRecipient: false
  }
  const [state, dispatch] = useReducer(fetchWallReducer, initialState)

  useEffect(() => {
    let isMounted = true

    const fetchWall = async () => {
      if (isMounted) {
        dispatch({ type: FETCH_DATA_INIT })
      }
      try {
        const input = { id: wallId }
        const result = await API.graphql(graphqlOperation(getWall, input))
        const userCard = result.data.getWall.cards.items.filter(
          item => item.senderId === userId
        )
        const isGreeted = userCard.length > 0
        const recipientWall = result.data.getWall.recipients.items.filter(
          item => item.recipientId === userId
        )
        
        let isRecipient = recipientWall.length > 0
        if (recipientToken && recipientWall.length === 0) {
          const input = {
            recipientId: userId,
            recipientName: userName,           
            createdAt: new Date().toISOString(),
            wallID: wallId
          }
          
          await API.graphql(graphqlOperation(createWallRecipient, { input }))
          isRecipient = true
        }

        if (isMounted) {
          await sleep(1500)

          dispatch({
            type: FETCH_DATA_SUCCESS,
            payload: {
              wall: result.data.getWall,
              isGreeted,
              isRecipient: isRecipient
            },
          })
        }
      } catch (error) {
        if (isMounted) {
          dispatch({ type: FETCH_DATA_FAILURE })
        }
      }
    }
/*
    const mockGreetingByCard = async () => {
      if (isMounted) {
        dispatch({ type: FETCH_DATA_INIT })

        await sleep(2000)

        dispatch({
          type: FETCH_DATA_SUCCESS,
          payload: {
            wall: {
              "id": "4758d5ba-2e57-448b-8ff9-a344e475739a",
              "status": "OPEN",
              "senderId": "115813804574865661469",
              "senderName":
                "John AF",
              "recipientId": null,
              "recipientName": null,
              "layout": "classic",
              "greetingType": "cards",
              "config": "{\"titleHtml\":\"<p><span style=\\\"color: rgb(255,255,255);font-size: 48px;font-family: Dancing Script;\\\"><strong>Happy Birthday Grace</strong></span></p>\\n\",\"subtitleHtml\":\"<p>&nbsp;<span style=\\\"color: rgb(97,189,109);font-size: 24px;font-family: Georgia;\\\"><strong>I</strong></span><span style=\\\"color: rgb(84,172,210);font-size: 24px;font-family: Georgia;\\\"><strong>s</strong></span><span style=\\\"color: rgb(147,101,184);font-size: 24px;font-family: Georgia;\\\"><strong>t</strong></span><span style=\\\"color: rgb(226,80,65);font-size: 24px;font-family: Georgia;\\\"><strong>'s</strong></span><span style=\\\"color: rgb(97,189,109);font-size: 24px;font-family: Georgia;\\\"><strong> B</strong></span><span style=\\\"color: rgb(184,49,47);font-size: 24px;font-family: Georgia;\\\"><strong>ir</strong></span><span style=\\\"color: rgb(97,189,109);background-color: rgb(255,182,193);font-size: 24px;font-family: Georgia;\\\"><strong>th</strong></span><span style=\\\"color: rgb(147,101,184);font-size: 24px;font-family: Georgia;\\\"><strong>da</strong></span><span style=\\\"color: rgb(97,189,109);font-size: 24px;font-family: Georgia;\\\"><strong>y</strong></span>&nbsp;</p>\\n\",\"bannerBgColor\":\"lightpink\",\"image\":{\"url\":\"/static/media/happy-birthday-cake-2020.efaf607f.jpg\",\"s3Key\":\"\",\"borderClass\":\"is-circle\"}}",
              "cards": { "items": [], "nextToken": null },
              "createdAt": "2020-09-14T12:04:34.017Z",
              "updatedAt": "2020-09-14T12:04:34.017Z"
            },
            isGreeted: false,
          },
        })
      }
    }

    const mockSocialGreeting = async () => {
      if (isMounted) {
        dispatch({ type: FETCH_DATA_INIT })

        await sleep(2000)

        dispatch({
          type: FETCH_DATA_SUCCESS,
          payload: {
            wall: {
              "id": "4758d5ba-2e57-448b-8ff9-a344e475739a",
              "status": "OPEN",
              "senderId": "115813804574865661469",
              "senderName":
                "John AF",
              "recipientId": null,
              "recipientName": null,
              "layout": "classic",
              "greetingType": "fb-comments",
              "config": "{\"bannerEffect\":\"confetti\",\"titleHtml\":\"<p><span style=\\\"color: rgb(255,255,255);font-size: 48px;font-family: Dancing Script;\\\"><strong>Happy Birthday Grace</strong></span></p>\\n\",\"subtitleHtml\":\"<p>&nbsp;<span style=\\\"color: rgb(97,189,109);font-size: 24px;font-family: Georgia;\\\"><strong>I</strong></span><span style=\\\"color: rgb(84,172,210);font-size: 24px;font-family: Georgia;\\\"><strong>s</strong></span><span style=\\\"color: rgb(147,101,184);font-size: 24px;font-family: Georgia;\\\"><strong>t</strong></span><span style=\\\"color: rgb(226,80,65);font-size: 24px;font-family: Georgia;\\\"><strong>'s</strong></span><span style=\\\"color: rgb(97,189,109);font-size: 24px;font-family: Georgia;\\\"><strong> B</strong></span><span style=\\\"color: rgb(184,49,47);font-size: 24px;font-family: Georgia;\\\"><strong>ir</strong></span><span style=\\\"color: rgb(97,189,109);background-color: rgb(255,182,193);font-size: 24px;font-family: Georgia;\\\"><strong>th</strong></span><span style=\\\"color: rgb(147,101,184);font-size: 24px;font-family: Georgia;\\\"><strong>da</strong></span><span style=\\\"color: rgb(97,189,109);font-size: 24px;font-family: Georgia;\\\"><strong>y</strong></span>&nbsp;</p>\\n\",\"bannerBgColor\":\"lightpink\",\"image\":{\"url\":\"/static/media/happy-birthday-cake-2020.efaf607f.jpg\",\"s3Key\":\"\",\"borderClass\":\"is-circle\"}}",
              "cards": { "items": [], "nextToken": null },
              "createdAt": "2020-09-14T12:04:34.017Z",
              "updatedAt": "2020-09-14T12:04:34.017Z"
            },
            isGreeted: false,
          },
        })
      }
    }
*/
    fetchWall()
    //mockGreetingByCard()
    //mockSocialGreeting()

    return () => {
      isMounted = false
    }
  }, [wallId, userId, userName, recipientToken])

  
  useEffect(() => {
    const createWallCardListener = API.graphql(
      graphqlOperation(onCreateWallCard)
    ).subscribe({
      next: productData => {
        const createdItem = productData.value.data.onCreateWallCard
        console.log("onCreateWallCard: " + JSON.stringify(createdItem))

        if (createdItem.wall.id === wallId) {
          console.log(state.wall)

          let updatedWall = { ...state.wall }

          if (state.wall.cards) {
            const prevItems = state.wall.cards.items.filter(
              item => item.id !== createdItem.id
            )
            const updatedItems = [createdItem, ...prevItems]
            updatedWall.cards.items = updatedItems
          } else {
            const updatedItems = [createdItem]
            updatedWall.cards.items = updatedItems
          }
          dispatch({ type: ADD_CARD, payload: updatedWall })
        }
      },
    })
    return () => {
      createWallCardListener.unsubscribe()
    }
  }, [state.wall, wallId])

  return state
}

export default useFetchWallData